

























































































import Vue from 'vue';
import * as api from '@/api';
import { ElForm } from 'element-ui/types/form';

export default Vue.extend({
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        const self: any = this;
        const validatePhone = (rule, value, callback) => {
            // if (!value.match(/^1[3-9]\d{9}$/)) {
            //     callback('手机号格式错误');
            // }
            callback();
        };
        const validatePass = (rule, value, callback) => {
            if (!self.registerForm.password) {
                callback('请输入密码');
            } else if (self.registerForm.confirmedPassword !== '') {
                self.$refs.register.validateField('confirmedPassword');
            }
            callback();
        };
        const validatePass2 = (rule, value, callback) => {
            if (!self.registerForm.confirmedPassword) {
                callback('请输入确认密码');
            } else if (self.registerForm.confirmedPassword !== self.registerForm.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        const validateCode = (rule, value, callback) => {
            if (!value) {
                callback('请输入验证码');
            } else if (!value.match(/^[0-9]{6}$/)) {
                callback('验证码格式错误');
            }
            callback();
        };
        return {
            tabIndex: 0,
            loginForm: {
                phoneNumber: '',
                password: '',
            },
            loginRules: {
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
            registerForm: {
                phoneNumber: '',
                verificationCode: '',
                password: '',
                confirmedPassword: '',
            },
            registerRules: {
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
                verificationCode: [
                    { validator: validateCode, trigger: 'blur' },
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' },
                    { min: 6, message: '密码至少为6个字符', trigger: 'blur' },
                ],
                confirmedPassword: [
                    { validator: validatePass2, trigger: 'blur' },
                ],
            },
            smsCountDown: 0,
        };
    },
    methods: {
        findPassword() {
            this.close();
            if (this.$route.name === 'FindPassword') {
                this.$router.push({ // 先进空路由刷新组件
                    path: '/findPassword/_empty',
                });
                setTimeout(() => {
                    this.$router.push({
                    path: '/findPassword',
                });
                }, 50);
            } else {
                this.$router.push({
                    path: '/findPassword',
                });
            }
        },
        close() {
            this.$store.commit('loginVisible', false);
        },
        switchTab(idx: number) {
            this.tabIndex = idx;
            (this.$refs.login as ElForm).clearValidate();
            (this.$refs.register as ElForm).clearValidate();
        },
        async login() {
            const valid = await (this.$refs.login as ElForm).validate();
            if (!valid) return;
            const res = await api.login({
                username: this.loginForm.phoneNumber,
                password: this.loginForm.password,
            });
            if ('error' in res) {
                // todo: 报错信息对用户不友好
                const infos = [
                    { idx: 1, message: '用户不存在' },
                    { idx: 2, message: '密码错误' },
                    { idx: 3, message: '该账号当前不可使用' },
                ];
                const info = infos.find((i) => i.idx === res.error_type);
                this.$message({
                    type: 'error',
                    message: info ? info.message : 'error',
                });
            } else {
                   this.$store.commit('loginVisible', false);
                   await this.$store.dispatch('setToken', res.access_token);
                if (this.$route.name === 'FindPassword') { // 重置密码登录则跳转首页
                    this.$router.push({
                        path: '/products',
                    });
                }
                if (this.$route.name === 'TaskFile') {
                    this.$router.push({
                        path: '/home-work',
                    });
                }
            }
        },
        async register() {
            try {
                await (this.$refs.register as ElForm).validate();
            } catch (e) {
                return;
            }
            const res = await api.register({
                phoneNumber: this.registerForm.phoneNumber,
                captcha: this.registerForm.verificationCode,
                password: this.registerForm.password,
            });
            if (!api.error(res)) {
                this.loginForm.phoneNumber = this.registerForm.phoneNumber;
                this.loginForm.password = this.registerForm.password;
                await this.login();
            } else {
                this.$message({
                    type: 'error',
                    message: res.error.message,
                });
            }
        },
        sendVerificationCode() {
            // todo: 连续点多次，会触发多条短信吗？
            (this.$refs.register as ElForm).validateField('phoneNumber', async (err) => {
                if (err) return;
                const res = await api.sendSMSCaptcha({
                    phoneNumber: this.registerForm.phoneNumber,
                });
                if (!api.error(res)) {
                    this.smsCountDown = 60;
                    const timer = setInterval(() => {
                        this.smsCountDown -= 1;
                        if (this.smsCountDown === 0) {
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.error.message,
                    });
                }
            });
        },
    },
});
